import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'

export const ChangeableContent = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'changed',
})<{ changed: boolean }>(({ changed }) => ({
  color: changed ? 'blue' : '',
  backgroundColor: changed ? '#F0F8FF' : '',
  display: 'inline',
}))
